import {
	SELF_FILES_LOADING_TRUE,
	SELF_FILES_LOADING_FALSE,
	SELF_FILES_LATEST_GET,
	SELF_FILES_LATEST_ERROR
} from '../actions/types';

const initialState = {
	loading: false,
	latestFile: {},
	error: null
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case SELF_FILES_LOADING_TRUE:
			return {
				...state,
				loading: true
			}
		case SELF_FILES_LOADING_FALSE:
			return {
				...state,
				loading: false
			}
		case SELF_FILES_LATEST_GET:
			return {
				...state,
				latestFile: action.payload,
				error: null
			}
		case SELF_FILES_LATEST_ERROR:
			return {
				...state,
				latestFile: {},
				error: action.payload
			}
		default:
			return state;
	}
}
